import classnames from 'classnames';

import './Spinner.scss';

export interface SpinnerProps {
    /**
     * Spinner color
     */
    color?:
        | 'primary'
        | 'secondary'
        | 'tertiary'
        | 'white'
        | 'gradient'
        | 'gradient-reverse'
        | 'gradient-1'
        | 'gradient-1-reverse'
        | 'gradient-2'
        | 'gradient-2-reverse'
        | 'gradient-3'
        | 'gradient-3-reverse'
        | 'gradient-4'
        | 'gradient-4-reverse'
        | 'gradient-secondary';
    /**
     * Size spinner
     */
    size?: number;
    /**
     * Class name styles
     */
    className?: string;
}

const Spinner: React.FC<SpinnerProps> = ({ color, size = 100, className }) => {
    const style = { width: `${size}px`, height: `${size}px` };
    const classNames = classnames(['spinner', color, className]);

    return (
        <div className={classNames}>
            <div className="spinner__wrapper rotating" style={style} />
        </div>
    );
};

export default Spinner;
